import { render, staticRenderFns } from "./InvestorProfile.vue?vue&type=template&id=79d64406&scoped=true"
import script from "./InvestorProfile.vue?vue&type=script&lang=js"
export * from "./InvestorProfile.vue?vue&type=script&lang=js"
import style0 from "./InvestorProfile.vue?vue&type=style&index=0&id=79d64406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d64406",
  null
  
)

export default component.exports